import Image from '@components/Image';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ItemCategory } from '@models/item/itemCategory';
import { CategoryKitIcon } from '@models/item/itemCategory/extension';
import { useMemo } from 'react';

function useCategoryIcon(category: ItemCategory) {
    const {
        iconImageUrl, iconKit, iconType,
    } = category;

    const Icon = iconKit ? CategoryKitIcon[iconKit] : undefined;
    const isKitIconVisible = iconType === 'KIT' && Icon;
    const isImageIconVisible = iconType === 'IMAGE' && iconImageUrl;

    return useMemo(() => {
        if (isImageIconVisible) {
            return (
                <IconImage src={iconImageUrl}
                    width={24}
                    height={24}/>
            );
        }
        if (isKitIconVisible) {
            return (<Icon color={colors.primary} size={24} />);
        }
        return undefined;
    }, [isKitIconVisible, isImageIconVisible]);
}

const IconImage = styled(Image)`
    border-radius: 24px;
    object-fit: cover;
`;

export default useCategoryIcon;
